import React from "react";

export const normalizeAdditionalSchemas = (schemas) =>
  Array.isArray(schemas)
    ? schemas.map((item) => ({
        schema_label: item?.schema_label || item?.label || "",
        schema_value: item?.schema_value || item?.schema || "",
      }))
    : [];

export const validateOptionalSchemas = (seoData) => {
  const schemas = [
    { label: "FAQ Schema", schema: seoData.faq_schema },
    { label: "Article Schema", schema: seoData.article_schema },
    ...normalizeAdditionalSchemas(seoData.additional_schemas).map((item) => ({
      label: item.schema_label || "Additional Schema",
      schema: item.schema_value,
    })),
  ];

  schemas.forEach((item) => {
    if (item.schema?.trim()) {
      JSON.parse(item.schema);
    }
  });
};

export default function AdditionalSchemas({ value = [], onChange, disabled = false }) {
  const schemas = normalizeAdditionalSchemas(value);
  const update = (index, field, fieldValue) => {
    onChange(
      schemas.map((item, itemIndex) =>
        itemIndex === index ? { ...item, [field]: fieldValue } : item
      )
    );
  };

  return (
    <>
      {schemas.map((item, index) => (
        <div className="add-content-wrap" key={`additional-schema-${index}`}>
          <div className="row">
            <div className="col-lg-12">
              <div className="add-page-inputs">
                <div className="label-wrap-add">
                  <label>Schema Label</label>
                </div>
                <input
                  type="text"
                  value={item.schema_label}
                  onChange={(event) => update(index, "schema_label", event.target.value)}
                  className="form-control"
                  placeholder="Example: Breadcrumb Schema"
                  disabled={disabled}
                />
              </div>
            </div>
            <div className="col-lg-12">
              <div className="add-page-inputs">
                <div className="label-wrap-add">
                  <label>Additional Schema</label>
                </div>
                <textarea
                  value={item.schema_value}
                  onChange={(event) => update(index, "schema_value", event.target.value)}
                  className="form-control"
                  rows="5"
                  style={{ height: "auto" }}
                  placeholder={'{"@context":"https://schema.org","@type":"BreadcrumbList"}'}
                  disabled={disabled}
                />
              </div>
            </div>
            <div className="col-lg-12">
              <button
                type="button"
                className="default-btn"
                onClick={() => onChange(schemas.filter((_, itemIndex) => itemIndex !== index))}
                disabled={disabled}
              >
                Remove Schema <span></span>
              </button>
            </div>
          </div>
        </div>
      ))}
      <button
        type="button"
        className="addmore-images-client w-100 seo-add-schema-btn"
        onClick={() => onChange([...schemas, { schema_label: "", schema_value: "" }])}
        disabled={disabled}
      >
        Add More Schema <span></span>
      </button>
    </>
  );
}
